import * as ReactDOM from "react-dom/client";
import "./styles.css";
import {
  createBrowserRouter,
  LoaderFunctionArgs,
  redirect,
  RouterProvider,
  Params,
} from "react-router-dom";
import * as Sentry from "@sentry/react";
import "@mollie/ui-assets/css/index.css";
import {
  defaultAppLanguage,
  isValidLanguage,
} from "@mollie/revenue-collection-intl";
import { UnexpectedRootErrorState } from "./components";
import { marketingUrl } from "app/constants";
import { AppWrapper } from "@mollie/revenue-collection-components";
import { InvoiceLandingPage, InvoicePaymentPage } from "app/pages";

const environment: Environment = import.meta.env.MODE as Environment;

if (environment === "stag" || environment === "prod") {
  Sentry.init({
    dsn: "https://5b37db02370f2931a700bc1e73358253@o29109.ingest.sentry.io/4506043603681280",
    environment: environment,
  });
}

const router = createBrowserRouter([
  {
    path: "/",
    loader: (): null => {
      window.location.replace(marketingUrl);

      return null;
    },
  },
  {
    path: "/:lang/*",
    element: <AppWrapper />,
    errorElement: <UnexpectedRootErrorState />,
    children: [
      {
        path: "invoice/:invoiceReferenceId",
        loader: ({ params }: LoaderFunctionArgs): Response | null => {
          return genericLoader(params);
        },
        element: <InvoiceLandingPage />,
      },
      {
        path: "invoice/:invoiceReferenceId/pay",
        loader: ({ params }: LoaderFunctionArgs): Response | null => {
          return genericLoader(params);
        },
        element: <InvoicePaymentPage />,
      },
      {
        path: "*",
        loader: ({ params }: LoaderFunctionArgs): null | Response => {
          const { lang } = params as { lang: string };

          if (!isValidLanguage(lang)) {
            return redirect(
              `/${defaultAppLanguage()}/${params.lang}/${params["*"]}`,
            );
          }

          window.location.replace(marketingUrl);

          return null;
        },
      },
    ],
  },
]);

function genericLoader(params: Params<string>) {
  const { lang } = params as { lang: string };

  if (!isValidLanguage(lang)) {
    return redirect(`/${defaultAppLanguage()}/${params["*"]}`);
  }

  if (params.invoiceReferenceId === undefined) {
    return redirect("/");
  }

  return null;
}

const documentRoot = document.getElementById("root");
if (documentRoot !== null) {
  ReactDOM.createRoot(documentRoot).render(<RouterProvider router={router} />);
}
